import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { BenefitsStrip } from './components/BenefitsStrip';
import { ProblemSection } from './components/ProblemSection';
import { NoNecesitasSection } from './components/NoNecesitasSection';
import { ProductIntro } from './components/ProductIntro';
import { TomosSection } from './components/TomosSection';
import { TomoCommonFeatures } from './components/TomoCommonFeatures';
import { InsideCarousel } from './components/InsideCarousel';
import { BenefitsGrid } from './components/BenefitsGrid';
import { BonosSection } from './components/BonosSection';
import { ValueStack } from './components/ValueStack';
import { PremiumIntro } from './components/PremiumIntro';
import { PremiumItem } from './components/PremiumItem';
import { PricingCards } from './components/PricingCards';
import { ComparisonTable } from './components/ComparisonTable';
import { TransformationSection } from './components/TransformationSection';
import { ProofSection } from './components/ProofSection';
import { ForWhoSection } from './components/ForWhoSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { PhraseSeparator } from './components/ui/PhraseSeparator';
export function App() {
  return <div className="min-h-full w-full bg-mp-black font-body" data-id="element-0" data-mp="2zmwhmy3ufmc9">
      <Header data-id="element-1" data-mp="33nq6btp41567" />
      <main data-id="element-2" data-mp="33ngfy505kvzz">
        <Hero data-id="element-3" data-mp="33mymth8sexwa" />
        <BenefitsStrip data-id="element-4" data-mp="33orkw85c49so" />
        <ProblemSection data-id="element-5" data-mp="38m1e7yvuh5ls" />
        <NoNecesitasSection data-id="element-6" data-mp="38kqc03i1s5ws" />
        <ProductIntro data-id="element-7" data-mp="38kgk2adfzoog" />
        <TomosSection data-id="element-8" data-mp="38o4d78ez692n" />
        <PhraseSeparator phrase="NO SOLAMENTE QUÉ ENSEÑAR. CÓMO ENSEÑARLO." data-id="element-9" data-mp="3dle28mygcipy" />
        <TomoCommonFeatures data-id="element-10" data-mp="nvj53kddcmru" />
        <InsideCarousel data-id="element-11" data-mp="nwc2vvuco1xu" />
        <BenefitsGrid data-id="element-12" data-mp="nv0z3w0wmu6q" />
        <BonosSection data-id="element-13" data-mp="nxn4pq48izmb" />
        <PhraseSeparator phrase="MENOS DISCURSO. MÁS CLARIDAD." tone="lime" data-id="element-14" data-mp="sudksdg1hv7q" />
        <ValueStack data-id="element-15" data-mp="swq8z8ce51t8" />
        <PremiumIntro data-id="element-16" data-mp="3684hdq2uasw" />
        <PremiumItem label="Extra Premium 01" title="El Mapa de Pista" tag="50 Esquemas Técnicos" copy={['La traducción visual de Maestro en Pista.', '50 esquemas de pista con posiciones, desplazamientos, conos y trayectorias para entender ejercicios y situaciones de juego de un vistazo.']} bigLine="MIRAS. ENTIENDES. MONTAS." smallNote={['Porque cuando estás en pista no quieres leer tres páginas para recordar un ejercicio.', 'Quieres verlo.']} imageLabel="Mapa de Pista" data-id="element-17" data-mp="35oy8u9shaup" />
        <PremiumItem label="Extra Premium 02" title="Programador 12 Meses" tag="Tu Calendario Anual" copy={['Una estructura anual para ayudarte a organizar qué trabajar durante la temporada y mantener una progresión más coherente a lo largo de los meses.']} bigLine="ABRES LA SEMANA. SABES QUÉ TOCA." smallNote={['Menos decisiones repetitivas.', 'Más continuidad.', 'Más control sobre la temporada.']} imageLabel="Programador 12 Meses" reverse data-id="element-18" data-mp="3qbpkqpcxycvk" />
        <PricingCards data-id="element-19" data-mp="1d6kkm9tu85l5" />
        <ComparisonTable data-id="element-20" data-mp="yfv8n58jymg8" />
        <PhraseSeparator phrase="DE TIRABOLAS A MONITOR CON MÉTODO." data-id="element-21" data-mp="ygmuhoccl5tb" />
        <TransformationSection data-id="element-22" data-mp="13eewxcamcabr" />
        <ProofSection data-id="element-23" data-mp="13fpzj8sbvc1a" />
        <ForWhoSection data-id="element-24" data-mp="13ey4q06k1ic2" />
        <FAQSection data-id="element-25" data-mp="13cc0a9eyniy2" />
        <FinalCTA data-id="element-26" data-mp="1r3r466mdy8bf" />
      </main>
      <Footer data-id="element-27" data-mp="1r5katlx00sjf" />
      <StickyMobileCTA data-id="element-28" data-mp="1r526s343ha0y" />
    </div>;
}